module.exports = {
	"permanent": "Постоянный",
	"buttons": {
		"cancel": "Отмена",
		"close": "Закрыть",
		"copy": "Копировать",
		"copyFile": "Скопировать файл",
		"copyToClipboard": "Скопировать в буфер",
		"create": "Создать",
		"delete": "Удалить",
		"download": "Скачать",
		"info": "Инфо",
		"more": "Еще",
		"move": "Переместить",
		"moveFile": "Переместить файл",
		"new": "Новый",
		"next": "Вперед",
		"ok": "OK",
		"replace": "Перезаписать",
		"previous": "Назад",
		"rename": "Переименовать",
		"reportIssue": "Сообщить о проблеме",
		"save": "Сохранить",
		"search": "Поиск",
		"select": "Выбрать",
		"share": "Поделиться",
		"publish": "Опубликовать",
		"selectMultiple": "Мультивыбор",
		"schedule": "Планировка",
		"switchView": "Вид",
		"toggleSidebar": "Боковая панель",
		"update": "Обновить",
		"upload": "Загрузить",
		"permalink": "Получить постоянную ссылку"
	},
	"success": {
		"linkCopied": "Ссылка скопирована!"
	},
	"errors": {
		"forbidden": "Доступ запрещен.",
		"internal": "Что-то пошло не так.",
		"notFound": "Неправильная ссылка."
	},
	"files": {
		"folders": "Каталоги",
		"files": "Файлы",
		"body": "Тело",
		"clear": "Очистить",
		"closePreview": "Закрыть",
		"home": "Дом",
		"lastModified": "Последнее изменение",
		"loading": "Загрузка...",
		"lonely": "Здесь пусто...",
		"metadata": "Метаданные",
		"multipleSelectionEnabled": "Мультивыбор включен",
		"name": "Имя",
		"size": "Размер",
		"sortByName": "Сортировка по имени",
		"sortBySize": "Сортировка по размеру",
		"sortByLastModified": "Сортировка по изменению"
	},
	"help": {
		"click": "выбрать файл или каталог",
		"ctrl": {
			"click": "выбрать несколько файлов или каталогов",
			"f": "открыть поиск",
			"s": "скачать файл или текущий каталог"
		},
		"del": "удалить выбранные элементы",
		"doubleClick": "открыть файл или каталог",
		"esc": "очистить выделение и/или закрыть окно",
		"f1": "помощь",
		"f2": "переименовать файл",
		"help": "Помощь"
	},
	"login": {
		"password": "Пароль",
		"submit": "Войти",
		"username": "Имя пользователя",
		"wrongCredentials": "Неверные данные"
	},
	"prompts": {
		"copy": "Копировать",
		"copyMessage": "Копировать в:",
		"currentlyNavigating": "Текущий каталог:",
		"deleteMessageMultiple": "Удалить эти файлы ({count})?",
		"deleteMessageSingle": "Удалить этот файл/каталог?",
		"deleteTitle": "Удалить файлы",
		"displayName": "Отображаемое имя:",
		"download": "Скачать файлы",
		"downloadMessage": "Скачать каталог в следующем формате.",
		"error": "Ошибка",
		"fileInfo": "Информация о файле",
		"filesSelected": "Файлов выбрано: {count}.",
		"lastModified": "Последнее изменение",
		"move": "Переместить",
		"moveMessage": "Переместить в:",
		"newDir": "Новый каталог",
		"newDirMessage": "Имя нового каталога.",
		"newFile": "Новый файл",
		"newFileMessage": "Имя нового файла.",
		"numberDirs": "Количество каталогов",
		"numberFiles": "Количество файлов",
		"replace": "Заменить",
		"replaceMessage": "Имя одного из загружаемых файлов совпадает с уже существующим файлом. Вы хотите заменить существующий?\n",
		"rename": "Переименовать",
		"renameMessage": "Новое имя",
		"show": "Показать",
		"size": "Размер",
		"schedule": "Планировка",
		"scheduleMessage": "Запланировать дату и время публикации.",
		"newArchetype": "Создайте новую запись на основе архетипа. Файл будет создан в каталоге."
	},
	"settings": {
		"admin": "Админ",
		"administrator": "Администратор",
		"allowCommands": "Запуск команд",
		"allowEdit": "Редактирование, переименование и удаление файлов или каталогов",
		"allowNew": "Создание новых файлов или каталогов",
		"allowPublish": "Публикация новых записей и страниц",
		"avoidChanges": "(пусто для пропуска)",
		"changePassword": "Изменение пароля",
		"commands": "Команды",
		"commandsHelp": "Здесь устанавливаются команды, выполняемые в названных событиях. Одна команда на строку. Если событие связано с файлами, например, после сохранения, переменной среды \"FILE\" будет присвоен путь файла.\n",
		"commandsUpdated": "Команды обновлены!",
		"customStylesheet": "Свой стиль",
		"examples": "Примеры",
		"globalSettings": "Глобальные настройки",
		"language": "Язык",
		"lockPassword": "Запретить пользователю менять пароль",
		"newPassword": "Новый пароль",
		"newPasswordConfirm": "Повтор нового пароля",
		"newUser": "Новый пользователь",
		"password": "Пароль",
		"passwordUpdated": "Пароль обновлен!",
		"permissions": "Права доступа",
		"permissionsHelp": "Можно настроить пользователя как администратора или выбрать разрешения индивидуально. При выборе \"Администратор\", все остальные параметры будут автоматически выбраны. Управление пользователями - привилегия администратора.\n",
		"profileSettings": "Настройки профиля",
		"ruleExample1": "предотвратить доступ к любому скрытому файлу (например: .git, .gitignore) в каждой папке.\n",
		"ruleExample2": "блокирует доступ к файлу с именем Caddyfile в корневой области.",
		"rules": "Права",
		"rulesHelp1": "Здесь вы можете определить набор разрешающих и запрещающих правил для этого конкретного пользователь. Блокированные файлы не будут отображаться в списках, и не будут доступны для пользователя. Есть поддержка регулярных выражений и относительных путей.\n",
		"rulesHelp2": "Каждое правило начинается с новой строки и должно начинаться с ключевого слова {0} или {1}. Затем {2}, если используются регулярное выражение, дальше выражение или путь.\n",
		"scope": "Корень",
		"settingsUpdated": "Настройки применены!",
		"user": "Пользователь",
		"userCommands": "Команды",
		"userCommandsHelp": "Список команд доступных пользователю, разделенный пробелами. Пример:\n",
		"userCreated": "Пользователь создан!",
		"userDeleted": "Пользователь удален!",
		"userManagement": "Управление пользователями",
		"username": "Имя пользователя",
		"users": "Пользователи",
		"userUpdated": "Пользователь изменен!"
	},
	"sidebar": {
		"help": "Помощь",
		"logout": "Выход",
		"myFiles": "Файлы",
		"newFile": "Новый файл",
		"newFolder": "Новый каталог",
		"settings": "Настройки",
		"siteSettings": "Настройки сайта",
		"hugoNew": "Hugo New",
		"preview": "Предпросмотр"
	},
	"search": {
		"images": "Изображения",
		"music": "Музыка",
		"notSupportedCommand": "Команда не поддерживается.",
		"pdf": "PDF",
		"pressToExecute": "Enter для запуска.",
		"pressToSearch": "Enter для поиска.",
		"search": "Поиск...",
		"searchOrCommand": "Поиск или выполнение команды...",
		"searchOrSupportedCommand": "Поиск или выполнение команды, начинающейся с '$':",
		"typeCommand": "Введи текст и нажми Enter для запуска.",
		"typeSearch": "Введи текст и нажми Enter для поиска.",
		"types": "Типы",
		"video": "Видео",
		"writeToSearch": "Введи текст для поиска"
	},
	"languages": {
		"en": "English",
		"fr": "Français",
		"pt": "Português",
		"ja": "日本語",
		"zhCN": "中文 (简体)",
		"zhTW": "中文 (繁體)",
		"es": "Español",
		"de": "Deutsch",
		"ru": "Русский"
	},
	"time": {
		"unit": "Единица времени",
		"seconds": "Секунды",
		"minutes": "Минуты",
		"hours": "Часы",
		"days": "Дни"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/ru.yaml
// module id = 295
// module chunks = 0